import { createAsyncThunk } from '@reduxjs/toolkit';
import userConfigurationService from './UserConfigurationService';

export const setUserConfigurationFCMTokenThunk = createAsyncThunk(
  'user/setUserConfigurationFCMTokenThunk',
  async (token: string, thunkAPI) => {
    await userConfigurationService.setFCMToken(token);
  },
);
